<script setup lang="ts">

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M11.3179 0.916898H13.9413L12.3518 8.06935C12.0431 9.4288 11.8322 10.263 11.7191 10.5719C12.1306 12.4669 12.7273 13.4144 13.5092 13.4144C14.4352 13.4144 14.9136 12.7759 14.9445 11.4989H15.5C15.4707 12.6935 15.2495 13.6616 14.8364 14.4031C14.4352 15.1343 13.9054 15.4999 13.2469 15.4999C12.7017 15.4999 12.2953 15.2785 12.0278 14.8357C11.7605 14.3928 11.4724 13.4865 11.1636 12.1168C10.0937 14.3723 8.34467 15.5 5.91669 15.5C4.2603 15.5 2.94342 14.8563 1.96605 13.569C0.988683 12.2713 0.5 10.4176 0.5 8.00771C0.5 5.63899 1.03499 3.79552 2.10498 2.47731C3.1749 1.1591 4.46091 0.5 5.963 0.5C7.02266 0.5 7.892 0.875908 8.57102 1.62772C9.25005 2.37954 9.85192 3.60509 10.3766 5.30437L11.3179 0.916898ZM9.95985 6.97256C9.47632 5.31446 8.93619 4.02196 8.33946 3.09506C7.74278 2.15787 7.02775 1.68928 6.19436 1.68928C4.31164 1.68928 3.37028 3.8932 3.37028 8.30105C3.37028 12.4823 4.2705 14.573 6.07093 14.573C7.6347 14.573 8.79211 12.7295 9.54315 9.04258L9.95985 6.97256Z" fill="#2563EB"/>
  </svg>
</template>

<style scoped lang="scss">

</style>
